import { screenSizeSwitch } from '../../../../../lib/helpers';
import TabButtonContainerBig from './TabButtonContainerBig';
import TabButtonContainerMedium from './TabButtonContainerMedium';
import TabButtonContainerSmall from './TabButtonContainerSmall';


export default screenSizeSwitch([[500, TabButtonContainerSmall], [767, TabButtonContainerMedium], TabButtonContainerBig]);
